import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class TipoVariavelService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'variavel/tipo');
  }

  // Método para buscar apenas sensores (tipo_variavel = "Sensor")
  indexSensores(): Observable<any> {
    // Busca todos e filtra no frontend, ou usa query parameter se a API suportar
    return this.http.get(`${this.url_base}/${this.prefixo}`);
  }

}

